@if (this.showSidebar$ | async) {
<div #sidebar
     class="sidebar-wrapper d-flex w-100 h-100">
  <div class="sidebar d-flex flex-column p-0 bg-white">
    <ng-content></ng-content>
    <div class="bg-gray mt-auto">
      <ng-content select="[sidebar-bottom]"></ng-content>
    </div>
  </div>
  @if (!this.isStatic) {
  <div class="overlay flex-grow-1"
       (click)="this.closeSidebarIfNotStatic()"></div>
  }
</div>
}